import React from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import ReactTooltip from 'react-tooltip';
// import Tooltip from "react-power-tooltip";
// import ReactDOM from 'react-dom';
import style from './style.module.css';
import UnitTypes from './UnitTypes';
import SpecificationsModal from './SpecificationsModal';
import CarouselModal from 'Components/MainScreen/AppBody/ShopMenu/ItemList/Item/CarouselModal';
import brokenImg from 'assets/brokenImg.jpg'
import MoreItemInfoModal from './MoreItemInfoModal';
import MouseWatcher from 'Components/MouseWatcher';
// import ProductsAssociatedModal from 'Components/MainScreen/AppBody/ProductsAssociatedModal';
import ReactPixel from 'react-facebook-pixel';
import { urlify } from 'utils/utils';

function ItemPrice({curr, price, promotion, isUnitMeasurementText, unitTypes, t}) {
    const salePrice = promotion?.percent ? (price * (100-promotion.percent)) / 100 : null;
    const line = promotion?.percent ? 'line-through' : 'none';
    return (
        <div className={style.ItemPrice}>
            { !salePrice || 
                <NumberFormat value={salePrice} prefix={curr} decimalScale={2} fixedDecimalScale={true} displayType={'text'}/> 
            }
            <NumberFormat value={price} prefix={curr} decimalScale={2} fixedDecimalScale={true} displayType={'text'} style={{textDecorationLine: line, marginLeft: '6px'}} />
            {
                unitTypes && unitTypes.length === 1 && (unitTypes[0].type  == 'kg' || unitTypes[0].type  == 'lb')
                &&
                <>
                / <small>{ t(unitTypes[0].type) }</small>
                </>
            }
            {isUnitMeasurementText && <div className={style.UnitMeasurementText}><small>{isUnitMeasurementText}</small></div>}
        </div>
    )
}

@inject(store => {
    const { myShopApiStore, ifaceMngr } = store;
    return { myShopApiStore, ifaceMngr };
})

@observer
class Item extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            show: false,
            left: 0,
            top: 0,
            unitTypeSelected: null,
            specModalIsOpen: false,
            carouselModalIsOpen: false,
            moreItemInfoModalIsOpen: false,
            productsAssociatedModalIsOpen: false,
            productsAssociated: null
        }
    }

    closeSpecModal = () => {
        this.setState({specModalIsOpen: false});
    }
    openSpecModal = () => {
        this.setState({specModalIsOpen: true});
    }

    setUnitTypeSelected = (unitType) => {
        this.setState({unitTypeSelected: unitType})
    }

    setLoading = () => {
        this.setState(prevState => ({
            loading: !prevState.loading
        }));
    }

    // getUnits(_item){
    //     const uType = _item ? _item.defaultUnitType : null;
    //     const { t } = this.props;
        
    //     return uType?t(uType):t('unit');
    // }

    showTooltip = event => {
        this.setState({
            show: true,
            top: event.target.getBoundingClientRect().top - 20,
            left: event.target.getBoundingClientRect().left + 90,
        });
    }

    hideTooltip = event => {
        this.setState({ show: false });
    }

    // countItems = item => {
    //     const { cartItemList, thisCart } = this.props.myShopApiStore;
    //     let count = 0;
    //     thisCart.cartItemList.forEach(cartItem => {
    //         if(cartItem.item.id === item.id) count++
    //     })
    //     return count;
    // }
    
    //return the item index (with same type) that added last to the cart;
    getIndexOfLastItemType = () => {
        const { item } = this.props;
        const { thisCart } = this.props.myShopApiStore;
        let cartItemIndex = null;
        thisCart.cartItemList.forEach((cartItem, idx) => {
            if(cartItem.item.id === item.id){
                cartItemIndex = idx;
            }
        })

        return cartItemIndex;
    }

    getItemAmount = () => {
        const { item } = this.props;
        const { thisCart } = this.props.myShopApiStore;
        let count = 0;
        thisCart.cartItemList.forEach(cartItem => {
            if(cartItem.item.id === item.id){
                const fixFloatingPoint = val => Number.parseFloat(val.toFixed(13))
                // cartItem.quantity = fixFloatingPoint(cartItem.quantity);
                count = fixFloatingPoint(count + cartItem.quantity)
                
                // count = Number.isInteger(count) ? count : count.toFixed(1);
            }
        });
        return count;
    }

    getItemUnit = () => {
        const { item } = this.props;
        const { thisCart } = this.props.myShopApiStore;

        const hasBaseToppings = item.shopBaseToppings?.length > 0;
        const hasToppings = item.shopToppings?.length > 0;
        const hasProductOptions = item.shopProductOptions?.length > 0;

        const hasMult = hasBaseToppings || hasToppings || hasProductOptions;

        let unit = this.state.unitTypeSelected ? this.state.unitTypeSelected.type : item.defaultUnitType;
        if(!hasMult) thisCart.cartItemList.forEach(cartItem => {
            if(cartItem.item.id === item.id){
                unit = cartItem.unitType.type
            }
        });
        return unit;
    }

    getItemUnitPrice = () => {
        const { item } = this.props;

        let unitPrice = item.unitTypes[0].price;
        let unit = this.getItemUnit();

        item.unitTypes.forEach(unitType => {
            if(unitType.type === unit){
                unitPrice = unitType.price
            }
        });

        return unitPrice;
    }

    handleAddClick = async (itemAssociated = null) => {
        const { addToCart, isPackItemUpdating,
                isCartItemUpdating } = this.props.myShopApiStore;
        const item = itemAssociated !== null ? itemAssociated : this.props.item;

        //this.props.toggleBasket(); 
        // in mobile -> openning the basket before 
        //the product has been added to the basket

        const unitTypes = item.unitTypes ? item.unitTypes : null;
        let isDuringOrder = isPackItemUpdating || isCartItemUpdating;

        if(!this.state.unitTypeSelected){
            this.setUnitTypeSelected(unitTypes[0]);
        }

        if(!isDuringOrder){
            //console.log('AddToCart');
            if(process.env.REACT_APP_FACEBOOK_PIXEL !== '') ReactPixel.track('AddToCart'); 

            if(itemAssociated){
                addToCart(item)
            }
            else{
                addToCart(item, this.state.unitTypeSelected ? this.state.unitTypeSelected : unitTypes[0])
            }
        }
    }
    
    openProductsAssociatedModal = () => {
        this.setState({productsAssociatedModalIsOpen: true});
    }
    closeProductsAssociatedModal = () => {
        this.setState({productsAssociatedModalIsOpen: false});
    }

    openCarouselModal = () => {
        this.setState({carouselModalIsOpen: true});
    }

    closeCarouselModal = () => {
        this.setState({carouselModalIsOpen: false});
    }

    changeBorkenImg = e => {
        e.target.src = brokenImg;
    }

    openMoreItemInfoModal = () => {
        this.setState({moreItemInfoModalIsOpen: true})
    }
    closeMoreItemInfoModal = () => {
        this.setState({moreItemInfoModalIsOpen: false})
    }

    render() {
        const { item, index, t } = this.props;
        const { removeCartItem,
                thisCart,
                closeCartItemForm,
                isCartItemUpdating,
                isPackItemUpdating,
                shop, shopData} = this.props.myShopApiStore;
        const product = item.product ?? null;
        
        const unitTypes = item.unitTypes ? item.unitTypes : null;
        const { currencyName } = shopData.country;
        
        //const units = this.getUnits(item);
        const desc = item.product ? item.product.description : null;

        const iFlags = [
            ...['isNew', 'isSale', 'isSeason'].filter(flag => item[flag]).map(flag => ({ flag, comment: null })),
            ...(item.promotions?.length ? [{ flag: item.promotions[0]?.name, comment: item.promotions[0]?.comment }] : []),
        ];
      
        const isItemInCart = thisCart.cartItemList.some(cartItem => cartItem.item.id === item.id);
        const hasProductOption = item.shopProductOptions ? item.shopProductOptions.length : false;
        const isEditableItem = hasProductOption || item.shopToppings.length;
        const isPackItem = item.product.levels ? item.product.levels.length : false;
        const isDuringOrder = isPackItemUpdating || isCartItemUpdating;
        const { isRTL } = this.props.ifaceMngr;
        const isUnitMeasurement = 
            item.product.hasUnits && !item.product.hasWeight 
            ? 
            (
                item.product.displayUnitTypeAmount  && item.product.displayUnitTypes
                ? 
                item.product.displayUnitTypeAmount + " " + t(item.product.displayUnitTypes.codename)
                :
                false
            )
            : 
            false;
        const isUnitMeasurementText = 
            isUnitMeasurement
            ?
            currencyName + parseFloat(((this.getItemUnitPrice()*item.product.displayUnitTypes.multiplier)/item.product.displayUnitTypeAmount).toFixed(2)).toFixed(2) + " " + t('per ') + item.product.displayUnitTypes.multiplier + " " + t(item.product.displayUnitTypes.codename)
            :
            "";
        

        const { imageBig } = this.props.item.product;
        return (
            <div className={style.Container}>
                <div className={style.modals}>
                {
                    imageBig && imageBig.length
                    ?
                        <CarouselModal modalIsOpen={this.state.carouselModalIsOpen} closeModal={this.closeCarouselModal} item={item}/>
                    :
                        ''
                }
                    <MoreItemInfoModal item={item} modalIsOpen={this.state.moreItemInfoModalIsOpen} closeModal={this.closeMoreItemInfoModal} />
                </div>
                <div className={style.TopDiv} data-ind={index} data-code={item.codename}>
                    <div className={style.DivRight}>
                        <div className={style.ItemImg} onClick={this.openCarouselModal}>
                            <img className={style.ItemImg}
                                src={product ? product.image : ''}
                                alt=''
                                onError={this.changeBorkenImg}
                            />
                        </div>
                        <div className={style.ItemFlags}>
                            {iFlags.map(({ flag, comment }, idx) => 
                                <div key={idx} className={style.iFlags} 
                                    style={{ backgroundColor: ['isNew', 'isSeason'].includes(flag) ? '#FF8000' : '#E10000' }}>
                                    {t(flag)}
                                    
                                    { !comment || 
                                    <>
                                        <span className={style.label} data-event='click focus' data-tip data-for={`comment_${idx}`}>🡸</span>

                                        <ReactTooltip 
                                            className={style.Tooltip}
                                            place={isRTL ? 'left' : 'right'}
                                            multiline={true}
                                            data-html={true}
                                            insecure={true} 
                                            id={`comment_${idx}`} 
                                            type='light' 
                                            border={true} 
                                            effect='solid'
                                            clickable={true}
                                            globalEventOff='click'
                                        >  
                                            <div dangerouslySetInnerHTML={{ __html: urlify(t(comment)) }} />
                                        </ReactTooltip>
                                    </>
                                    }
                            </div>
                            )}
                        </div>
                    </div>
                    <div className={style.DivMid}>
                        <div className={style.ItemName}
                            ref={ref => { this.refItem = ref }}
                        >
                            <div>
                                { product ? product.name : '' }
                                {isUnitMeasurement && <div className={style.UnitMeasurement}><small>{isUnitMeasurement}</small></div>}
                            </div>
                            <div className={style.DivLeftUp}>
                                <SpecificationsModal item={item} modalIsOpen={this.state.specModalIsOpen} closeModal={this.closeSpecModal}/>
                                {
                                    !item.product.technical_description ||
                                        <div className={style.TechDescOuterDiv} onClick={this.openSpecModal}>{t('Specifications')}</div>
                                }
                                {
                                    !desc ||
                                        <div className={style.DescOuterDiv} /*onClick={this.openMoreItemInfoModal}*/>
                                                <div className={style.label} data-event='click focus'
                                                    data-tip data-for={`moreInfo_${item.id}`}
                                                >
                                                    ?
                                                </div>
                                                <ReactTooltip 
                                                    className={style.Tooltip}
                                                    place={ isRTL ? 'right' : 'left' }
                                                    multiline={true}
                                                    data-html={true}
                                                    insecure={true} 
                                                    id={`moreInfo_${item.id}`} 
                                                    type='light' 
                                                    border={true} 
                                                    effect='solid'
                                                    clickable={true}
                                                    globalEventOff='click'
                                                >  
                                                    <div dangerouslySetInnerHTML={{ __html: urlify(desc)}}/>
                                                </ReactTooltip>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className={style.DivLeftLeft}>
                            <div className={style.DivLeftLeft1}>
                                {!shop.isBusiness && !!unitTypes &&
                                    <ItemPrice curr={ currencyName }
                                        price={ this.getItemUnitPrice() } 
                                        promotion={ item.promotions?.length ? item.promotions[0] : null }
                                        isUnitMeasurementText={isUnitMeasurementText}
                                        unitTypes={unitTypes}
                                        t={t}
                                    />
                                }
                            </div>
                            <div className={style.DivLeftLeft2}>
                                <div className={style.ItemUnits}>
                                    {
                                        unitTypes && unitTypes.length > 1 &&
                                            <UnitTypes unitTypes={unitTypes} selected={this.getItemUnit()} item={item} setUnitTypeSelected={this.setUnitTypeSelected}/>
                                    }
                                </div>
                                { 
                                shop.paymentSystem == 'stripe' && shop.paymentEndpoint == null
                                ?
                                null
                                :
                                <>
          
                                    {(isItemInCart && !isEditableItem && !isPackItem && this.getItemAmount() > 0) ?
                                        (
                                            <div className={style.DivLeftBottom}>
                                                <div className={style.PlusButton} onClick={() => this.handleAddClick()}>+</div>
                                                <div className={style.ItemAmount}>{this.getItemAmount()}</div>
                                                <div className={style.MinusButton} onClick={() => {
                                                    if(!isDuringOrder){
                                                        removeCartItem(this.getIndexOfLastItemType(), true);
                                                        closeCartItemForm();}
                                                    }}>-</div>
                                            </div>
                                        ) :
                                        (
                                            <div className={style.DivLeftBottom} onClick={() => this.handleAddClick()}>
                                                <div className={style.PlusLeftButton}>+</div>
                                                <div className={style.BtnLeftButton}>{t('add')}</div>
                                            </div>
                                        )
                                    }
                                </>
                                }
                            </div>
                        </div>
                    </div>
                    
                </div>
                {
                    item.isStock ? '' : 
                        <div className={style.DivNotInStock}>
                            <div className={style.Note}>{t('out of stock')}!</div>
                        </div>
                }
            </div>
        )
    }
}

export default withTranslation()(Item);
